import { useContext } from 'react';
import { IconElements } from '../../../../config/icons';
import { FundsQueryContext } from '../../../../contexts/funds-robot/FundsQueryContext';
import { FundsSelectionScreen } from '../../funds-selection-screen/FundsSelectionScreen';
import { ModalScreenFunds } from '../../../general/ModalScreen';

export const FundsSelectionModal: React.FC<{ isShown: boolean; onClose: () => void }> = ({ isShown, onClose }) => {
    const fundsQueryContext = useContext(FundsQueryContext);

    return (
        <ModalScreenFunds isShown={isShown}>
            <div className="flex flex-1 justify-center transform transition-all sm:align-middle my-4">
                <FundsSelectionScreen
                    sections={[
                        {
                            fundCategory: 'Portfolio',
                            funds: fundsQueryContext.assets.all.filter((asset) => asset.category === 'Portfolio'),
                        },
                        {
                            fundCategory: 'Stock',
                            funds: fundsQueryContext.assets.all.filter((asset) => asset.category === 'Stock'),
                        },
                        {
                            fundCategory: 'Bond',
                            funds: fundsQueryContext.assets.all.filter((asset) => asset.category === 'Bond'),
                        },
                    ]}
                    className="bg-transparent text-base flex-1"
                    titleBox={
                        <div className="flex px-4 flex-row w-full max-w-screen-lg md:text-5xl">
                            <button
                                className="flex items-end ml-auto mr-8 focus:outline-none cursor-pointer"
                                onClick={onClose}
                            >
                                <IconElements.Cross className="text-white h-6 w-6 md:h-12 md:w-12 hover:text-bnd-green transition" />
                            </button>
                        </div>
                    }
                    areTitlesWhite={true}
                />
            </div>
        </ModalScreenFunds>
    );
};
